module.exports = __webpack_public_path__ + "static/media/iphone_12_pro_silver.9b1ac761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_pro_silver.png
// module id = 2094
// module chunks = 0